import React from 'react';
import { DateRangeParam } from '../../types/DateRangeParam';
import { byName } from '../../utils/formParamsUtils';
import { BasicRange } from './BasicRange';

type DateRange = {
  dateRangeParam: DateRangeParam<'daterange'>;
  labelStartDate: string;
  labelEndDate: string;
};

export function DateRange({ labelStartDate, labelEndDate, dateRangeParam }: DateRange) {
  return (
    <BasicRange
      start={dateRangeParam.params.find(byName('startDate'))}
      end={dateRangeParam.params.find(byName('endDate'))}
      labelStart={labelStartDate}
      labelEnd={labelEndDate}
    />
  );
}
